import { Divider, Menu, Typography } from '@material-ui/core';
import React, { FC } from 'react';

import { Action } from 'src/StatusLabel';
import { StatusLabelClassNames } from 'src/types';

import { StatusLabelMenuActions } from './StatusLabelMenuActions';

const MenuItem: FC = ({ children }) => (
  <Typography component="li" variant="overline">
    {children}
  </Typography>
);

export interface StatusLabelMenuProps {
  options: {
    fullLabel?: string;
    additionalInfo?: string[];
  };
  actions: Action[];
  anchorEl: null | HTMLElement;
  handleClose: () => void;
}

export const StatusLabelMenu: FC<StatusLabelMenuProps> = ({
  handleClose,
  options: { additionalInfo = [], fullLabel = '' },
  anchorEl,
  actions,
}) => {
  const hasFullLabel = !!fullLabel;
  const hasAdditionalInfo = !!additionalInfo.length;
  const hasActions = !!actions.length;

  return (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
      classes={{ paper: StatusLabelClassNames.MENU_PAPER }}
      elevation={0}
      getContentAnchorEl={null}
      keepMounted
      MenuListProps={{ className: StatusLabelClassNames.MENU_CONTAINER }}
      onClose={handleClose}
      open={Boolean(anchorEl)}
      role="menu"
    >
      {hasFullLabel && <MenuItem>{fullLabel}</MenuItem>}
      {hasFullLabel && (hasAdditionalInfo || hasActions) && <Divider />}
      {additionalInfo.map(info => (
        <MenuItem key={info}>{info}</MenuItem>
      ))}
      {hasAdditionalInfo && hasActions && <Divider />}
      {hasActions && <StatusLabelMenuActions actions={actions} handleClose={handleClose} />}
    </Menu>
  );
};
